module.exports = __webpack_public_path__ + "static/img/344.1667dac.png";